import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filtrarContactos'
})
//Filtro para poder mostrar a que contactos ya se le han enviado las cotizaciones o confirmaciones
export class FiltrarContactosPipe implements PipeTransform {

    constructor(){}
       //Recibe un contacto  y  el objeto de los contactos a quienes se les ha enviado la cotizacion 
    transform(contacto:any, objetoContactos:any): any {
        if(objetoContactos != null){
            let existe= objetoContactos[contacto.$key];
            return existe;
        }else 
            return undefined
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtro-contactos.pipe.ts